import React, {useEffect, useState} from 'react';
import {getSiteKey, verifyRecaptcha} from "../../Actions/Recaptcha.action";
import {translate} from "../../Services/translation";

const Recaptcha = (props) => {

    const [showError, setShowError] = useState(false);

    useEffect(() => {
        let inputElement = document.getElementById(props.submitId)
        inputElement.disabled = true;
    }, []);

    useEffect(async () => {
        let siteKey = await getSiteKey();
        grecaptcha.ready(function () {
            grecaptcha.render("recaptcha-container", {
                "sitekey": siteKey,
                "callback": onRecaptchaCallback
            });
        });
    }, []);

    const onRecaptchaCallback = (token) => {
        let inputElement = document.getElementById(props.submitId)
        verifyRecaptcha(token)
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    inputElement.disabled = false;
                } else {
                    setShowError(true);
                }
            })
    }

    return (
        <>
            {showError
                ? <div className="error-message">{translate('recaptcha.error')}</div>
                : <div id="recaptcha-container"></div>
            }
        </>
    );
}

export default Recaptcha;